import React from "react";
import { Link } from "react-router-dom";
import { ScanSearch } from "lucide-react";

/** Adresse de l'analyse d'une combinaison, numéros pré-remplis (lus par numerosDepuisAdresse). */
export const adresseAnalyse = (numeros: number[]) => `/analyse-combinaison-keno/?numeros=${[...numeros].sort((a, b) => a - b).join(",")}`;

/**
 * « Analyser » (loupe + texte) à côté d'une paire, d'un trio ou d'une grille : mène à l'analyse de la
 * combinaison. Les boules elles-mêmes ne sont pas cliquables (décision du 26/10/2026).
 * `compact` : la loupe seule, pour les listes serrées (le texte reste lu par les lecteurs d'écran).
 * `enLigne` : sans marges de colonne, parmi d'autres boutons (cartes de grilles, barres d'actions).
 */
export const LienAnalyseCombinaison = ({ numeros, compact = false, enLigne = false, natif = false }: { numeros: number[]; compact?: boolean; enLigne?: boolean; natif?: boolean }) => {
  const tries = [...numeros].sort((a, b) => a - b);
  const props = {
    className: ["km-lien-analyse", compact ? "km-lien-analyse--compact" : "", enLigne ? "km-lien-analyse--en-ligne" : ""].filter(Boolean).join(" "),
    "aria-label": `Analyser la combinaison ${tries.join(", ")}`,
    title: "Analyser cette combinaison : écart, dernière sortie, historique",
  };
  const contenu = <><ScanSearch aria-hidden="true" />{!compact && <span>Analyser</span>}</>;
  // `natif` : lien HTML simple, pour les îlots des pages serveur rendus sans routeur React.
  return natif ? <a href={adresseAnalyse(tries)} {...props}>{contenu}</a> : <Link to={adresseAnalyse(tries)} {...props}>{contenu}</Link>;
};
